<template>
	<div class="graph">
        <ScaleTabs
			v-bind:scale="scale"
			:scales="scales"
			@change="setScale"></ScaleTabs>
        <DatePicker
			v-bind:date="date"
			v-bind:startDate="startDate"
			@previous="previous"
			@next="next"></DatePicker>
		<ExcretionGraph1D
			v-bind:data="excretionData"
			v-bind:startDate="startDate"
			v-bind:date="date"
			v-bind:interval="interval"
			v-bind:binWidth="binWidth">
		</ExcretionGraph1D>
	</div>
</template>

<script>
import Graph from './index'

export default {
	name: 'excretion-graph',
	extends: Graph,

	computed: {
		/**
		 * @function 	excretionData
		 * @desc		Returns the excretion data with its time, form and color
		 */
		excretionData() {
			return this.data.map((excretion) => {
				let point

				// Adding time
				if (excretion.date_time)
					point = { time: excretion.date_time }
				else
					point = { time: excretion.created }

				// Adding Form
				if (excretion.form)
					point.form = excretion.form

				// Adding Color
				if (excretion.color)
					point.color = excretion.color
				

				return point
			})
		}
	}
}
</script>
